import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    gridRating: {
        textAlign: 'center'
    },
    rating: {
        direction: 'rtl'
    },
    title: {
        paddingTop: 20,
        paddingRight: 20 ,
        marginBottom : 30
    },
    gridRatingTitle: {
        display: 'flex',
        justifyContent: 'center',
    },
    ratingTitleBad: {
        color: theme.palette.color.red,
        backgroundColor: theme.palette.color.redLight,
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 4,
        paddingBottom: 4,
        borderRadius: 7,
        display: 'inline-block',
    },
    ratingTitleGood: {
        color: theme.palette.color.green,
        backgroundColor: theme.palette.color.greenLight,
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 4,
        paddingBottom: 4,
        borderRadius: 7,
        display: 'inline-block',
    },
    tabStrength: {
        color: theme.palette.primary.main
    },
    tabWeakPoint: {
        color: theme.palette.secondary.main
    },
    reasonList: {
        marginTop: 10,
        paddingRight: 10,
        paddingLeft: 10,
    },
    reasonListBtn: {
        fontSize: 12,
        borderRadius: 15,
        padding: 2
    },
    gridComment: {
        margin: 30,
    },
    cardBottom: {
        bottom: 0,
        position: 'fixed',
        width: '100%',
        padding: 10,
        backgroundColor: theme.palette.background.card
      },
}))
